import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["payload"],
  _excluded2 = ["payload"];
import React, { useCallback, useMemo, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { InternalCommerceTelemetryIntegrations } from '@atlassian/commerce-telemetry';
import { CC_STATE_PROVIDER } from '../../common/constants/breadcrumb-names';
import { Breadcrumb } from '../../common/utils/events';
import { FormStartTimeProvider } from '../../common/utils/start-time';
import { composeState, stateGuard } from '../../common/utils/state';
import { SafeGuard } from '../../common/utils/telemetry-safe-guard';
import { useStripeService as useStripeServiceDI } from '../../services/stripe';
import { formContext, retryContext } from '../context';
import { FormStateController } from '../form-fields';
import { StripeProvider } from '../hooks/use-commerce-stripe';
import { useStripePromise } from '../utils';
var EMPTY_TOKEN = {};
export var BaseCreditCardFormState = function BaseCreditCardFormState(_ref) {
  var commerceService = _ref.commerceService,
    _ref$useStripeService = _ref.useStripeService,
    useStripeService = _ref$useStripeService === void 0 ? useStripeServiceDI : _ref$useStripeService,
    children = _ref.children,
    isTelemetryRootDisabled = _ref.isTelemetryRootDisabled;
  var _commerceService$toke = commerceService.token,
    _commerceService$toke2 = _commerceService$toke.payload,
    token = _commerceService$toke2 === void 0 ? EMPTY_TOKEN : _commerceService$toke2,
    tokenState = _objectWithoutProperties(_commerceService$toke, _excluded);
  var _useStripeService = useStripeService(token.publicKey),
    stripe = _useStripeService.payload,
    stripeState = _objectWithoutProperties(_useStripeService, _excluded2);
  var _composeState = composeState(tokenState, stripeState),
    state = _composeState.state,
    error = _composeState.error;
  var formState = stateGuard(stripe, state, error);
  var contextValue = useMemo(function () {
    return {
      token: token,
      state: formState.state,
      fieldConfigs: commerceService.fieldConfigs
    };
  }, [formState.state, token, commerceService.fieldConfigs]);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    retryKey = _useState2[0],
    setRetryKey = _useState2[1];
  var retry = useCallback(function () {
    return setRetryKey(function (oldKey) {
      return oldKey + 1;
    });
  }, []);
  var cardElement = /*#__PURE__*/React.createElement(SafeGuard, null, /*#__PURE__*/React.createElement(Breadcrumb, {
    name: CC_STATE_PROVIDER,
    isForDevsOnly: true
  }, /*#__PURE__*/React.createElement(StripeProvider, {
    value: stripe
  }, /*#__PURE__*/React.createElement(retryContext.Provider, {
    value: retry,
    key: retryKey
  }, /*#__PURE__*/React.createElement(formContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(FormStateController, null, /*#__PURE__*/React.createElement(Elements, {
    stripe: useStripePromise(formState.payload || null)
  }, children)))))));
  if (isTelemetryRootDisabled) {
    return /*#__PURE__*/React.createElement(FormStartTimeProvider, null, cardElement);
  }
  return /*#__PURE__*/React.createElement(FormStartTimeProvider, null, /*#__PURE__*/React.createElement(InternalCommerceTelemetryIntegrations, null, cardElement));
};